import { slotBarSymbolNames, slotSpineKey } from '../constants/symbolsNames';
import { isMobile } from '../helpers/isMobile';

const fonts = {
  font: { name: 'HEYCAZpersonal', path: 'atlasesNew/fonts/HEYCAZpersonal.otf' },
  font1: { name: 'poppinsMedium', path: 'atlasesNew/fonts/poppinsMedium.ttf' },
};

const bitmapFonts = {
  numbersJackpot: { name: 'numbersJackpot', path: 'atlasesNew/bitmapFonts/numbersJackpot.xml' },
  fontWildWeen: { name: 'fontWildWeen', path: 'atlasesNew/bitmapFonts/fontWildWeen.xml' },
};

const webSceneSpineResources = {
  1: {
    name: slotBarSymbolNames.icon1,
    path: 'atlasesNew/slotCharacters/web/symbol1/symbol1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/symbol1/symbol1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  2: {
    name: slotBarSymbolNames.icon2,
    path: 'atlasesNew/slotCharacters/web/symbol2/symbol2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/symbol2/symbol2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  3: {
    name: slotBarSymbolNames.icon3,
    path: 'atlasesNew/slotCharacters/web/symbol3/symbol3.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/symbol3/symbol3.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  4: {
    name: slotBarSymbolNames.icon4,
    path: 'atlasesNew/slotCharacters/web/symbol4/symbol4.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/symbol4/symbol4.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  5: {
    name: slotBarSymbolNames.icon5,
    path: 'atlasesNew/slotCharacters/web/symbol5/symbol5.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/symbol5/symbol5.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  6: {
    name: slotBarSymbolNames.icon6,
    path: 'atlasesNew/slotCharacters/web/symbol6/symbol6.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/symbol6/symbol6.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  7: {
    name: slotBarSymbolNames.icon7,
    path: 'atlasesNew/slotCharacters/web/symbol7/symbol7.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/symbol7/symbol7.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  8: {
    name: slotBarSymbolNames.icon8,
    path: 'atlasesNew/slotCharacters/web/symbol8/symbol8.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/symbol8/symbol8.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  9: {
    name: slotBarSymbolNames.icon9,
    path: 'atlasesNew/slotCharacters/web/wild/wild.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/wild/wild.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  10: {
    name: slotBarSymbolNames.icon10,
    path: 'atlasesNew/slotCharacters/web/scatter1/scatter1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/scatter1/scatter1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  11: {
    name: slotBarSymbolNames.icon11,
    path: 'atlasesNew/slotCharacters/web/scatter2/scatter2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/scatter2/scatter2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  400: {
    name: slotBarSymbolNames.icon12,
    path: 'atlasesNew/slotCharacters/web/jackpotSymbol/jackpotSymbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/web/jackpotSymbol/jackpotSymbol.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  mainBg: {
    name: slotSpineKey.mainBg,
    path: 'atlasesNew/background/web/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/background/web/background.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  gameLogo: {
    name: slotSpineKey.gameLogo,
    path: 'atlasesNew/gameLogo/web/gameLogo.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/gameLogo/web/gameLogo.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  jackpotCongratsPopup: {
    name: slotSpineKey.jackpotCongratsPopup,
    path: 'atlasesNew/jackpotAssets/web/jackpotCongratsPopup/InGame_PopUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/web/jackpotCongratsPopup/InGame_PopUp.atlas',
      },
    },
  },
  jackpotGameSceneBoard: {
    name: slotSpineKey.jackpotGameSceneBoard,
    path: 'atlasesNew/jackpotAssets/web/jackpotBgScene/background_web.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/web/jackpotBgScene/background_web.atlas',
      },
    },
  },
  jackPotItem: {
    name: slotSpineKey.jackPotItem,
    path: 'atlasesNew/jackpotAssets/web/jackpotSymbolContainer/container.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/web/jackpotSymbolContainer/container.atlas',
      },
    },
  },
  jackpotAmountBoard: {
    name: slotSpineKey.jackpotAmountBoard,
    path: 'atlasesNew/jackpotAssets/web/jackpotAmountBoard/Amount_containers.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/web/jackpotAmountBoard/Amount_containers.atlas',
      },
    },
  },
  jackPotSymbol: {
    name: slotSpineKey.jackPotSymbol,
    path: 'atlasesNew/jackpotAssets/web/jackpotIcons/jackpotSymbols.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/web/jackpotIcons/jackpotSymbols.atlas',
      },
    },
  },
  jackpotWinPopup: {
    name: slotSpineKey.jackpotWinPopup,
    path: 'atlasesNew/jackpotAssets/web/jackpotWinPopupAnimation/win.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/web/jackpotWinPopupAnimation/win.atlas',
      },
    },
  },
  winPopup: {
    name: slotSpineKey.winPopup,
    path: 'atlasesNew/winPopups/web/winPopups.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/winPopups/web/winPopups.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winLine: {
    name: slotSpineKey.winLine,
    path: 'atlasesNew/line/web/winningLine.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/line/web/winningLine.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winSymbolBorder: {
    name: slotSpineKey.winSymbolBorder,
    path: 'atlasesNew/winSymbolBorder/web/winFrame.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/winSymbolBorder/web/winFrame.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  gambleAmountFrame: {
    name: slotSpineKey.gambleAmountFrame,
    path: 'atlasesNew/gambleFuture/web/amountFrame/amount.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/gambleFuture/web/amountFrame/amount.atlas',
      },
    },
  },
  gambleCard: {
    name: slotSpineKey.gambleCard,
    path: 'atlasesNew/gambleFuture/web/card/card.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/gambleFuture/web/card/card.atlas',
      },
    },
  },
  gambleSymbol: {
    name: slotSpineKey.gambleSymbol,
    path: 'atlasesNew/gambleFuture/web/symbol/symbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/gambleFuture/web/symbol/symbol.atlas',
      },
    },
  },
  winCoin: {
    name: slotSpineKey.winCoin,
    path: 'atlasesNew/winCoin/web/winCoin.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/winCoin/web/winCoin.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelLamp: {
    name: slotSpineKey.wheelLamp,
    path: 'atlasesNew/boostedJackpotAtlases/wheelLamp/web/wheelLamp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/wheelLamp/web/wheelLamp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelBlueBoard: {
    name: slotSpineKey.wheelBlueBoard,
    path: 'atlasesNew/boostedJackpotAtlases/wheelBlueBoard/web/wheelBlueBoard.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/wheelBlueBoard/web/wheelBlueBoard.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelSpinIcon: {
    name: slotSpineKey.wheelSpinIcon,
    path: 'atlasesNew/boostedJackpotAtlases/spinButton/web/spinButton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/spinButton/web/spinButton.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelIcon: {
    name: slotSpineKey.wheelIcon,
    path: 'atlasesNew/boostedJackpotAtlases/wheelIcon/web/wheelIcon1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/wheelIcon/web/wheelIcon1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  popup: {
    name: slotSpineKey.popup,
    path: 'atlasesNew/boostedJackpotAtlases/popup/web/popUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/popup/web/popUp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  lightning: {
    name: slotSpineKey.lightning,
    path: 'atlasesNew/boostedJackpotAtlases/lightning/web/lightning.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/lightning/web/lightning.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

const mobileSceneSpineResources = {
  1: {
    name: slotBarSymbolNames.icon1,
    path: 'atlasesNew/slotCharacters/mobile/symbol1/symbol1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/symbol1/symbol1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  2: {
    name: slotBarSymbolNames.icon2,
    path: 'atlasesNew/slotCharacters/mobile/symbol2/symbol2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/symbol2/symbol2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  3: {
    name: slotBarSymbolNames.icon3,
    path: 'atlasesNew/slotCharacters/mobile/symbol3/symbol3.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/symbol3/symbol3.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  4: {
    name: slotBarSymbolNames.icon4,
    path: 'atlasesNew/slotCharacters/mobile/symbol4/symbol4.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/symbol4/symbol4.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  5: {
    name: slotBarSymbolNames.icon5,
    path: 'atlasesNew/slotCharacters/mobile/symbol5/symbol5.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/symbol5/symbol5.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  6: {
    name: slotBarSymbolNames.icon6,
    path: 'atlasesNew/slotCharacters/mobile/symbol6/symbol6.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/symbol6/symbol6.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  7: {
    name: slotBarSymbolNames.icon7,
    path: 'atlasesNew/slotCharacters/mobile/symbol7/symbol7.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/symbol7/symbol7.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  8: {
    name: slotBarSymbolNames.icon8,
    path: 'atlasesNew/slotCharacters/mobile/symbol8/symbol8.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/symbol8/symbol8.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  9: {
    name: slotBarSymbolNames.icon9,
    path: 'atlasesNew/slotCharacters/mobile/wild/wild.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/wild/wild.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  10: {
    name: slotBarSymbolNames.icon10,
    path: 'atlasesNew/slotCharacters/mobile/scatter1/scatter1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/scatter1/scatter1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  11: {
    name: slotBarSymbolNames.icon11,
    path: 'atlasesNew/slotCharacters/mobile/scatter2/scatter2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/scatter2/scatter2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  400: {
    name: slotBarSymbolNames.icon12,
    path: 'atlasesNew/slotCharacters/mobile/jackpotSymbol/jackpotSymbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/slotCharacters/mobile/jackpotSymbol/jackpotSymbol.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  jackpotCongratsPopup: {
    name: slotSpineKey.jackpotCongratsPopup,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotCongratsPopup/InGame_PopUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotCongratsPopup/InGame_PopUp.atlas',
      },
    },
  },
  jackpotGameSceneBoard: {
    name: slotSpineKey.jackpotGameSceneBoard,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotBgScene/background_web.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotBgScene/background_web.atlas',
      },
    },
  },
  jackpotBackGroundLights: {
    name: slotSpineKey.jackpotBackGroundLights,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_lights.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_lights.atlas',
      },
    },
  },
  jackpotBackGroundLogo: {
    name: slotSpineKey.jackpotBackGroundLogo,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_logo.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_logo.atlas',
      },
    },
  },
  jackpotBackGroundProjector: {
    name: slotSpineKey.jackpotBackGroundProjector,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_projector.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_projector.atlas',
      },
    },
  },
  jackpotBackGroundStage: {
    name: slotSpineKey.jackpotBackGroundStage,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_stage.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_stage.atlas',
      },
    },
  },
  jackpotBackGroundStars: {
    name: slotSpineKey.jackpotBackGroundStars,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_stars.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotBackGround/bg_stars.atlas',
      },
    },
  },
  jackPotItem: {
    name: slotSpineKey.jackPotItem,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotSymbolContainer/container.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotSymbolContainer/container.atlas',
      },
    },
  },
  jackpotAmountBoard: {
    name: slotSpineKey.jackpotAmountBoard,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.json',
    config: {
      metadata: {
        spineAtlasFile:
          'atlasesNew/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.atlas',
      },
    },
  },
  jackPotSymbol: {
    name: slotSpineKey.jackPotSymbol,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.atlas',
      },
    },
  },
  jackpotWinPopup: {
    name: slotSpineKey.jackpotWinPopup,
    path: 'atlasesNew/jackpotAssets/mobile/jackpotWinPopupAnimation/win.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/jackpotAssets/mobile/jackpotWinPopupAnimation/win.atlas',
      },
    },
  },
  winPopup: {
    name: slotSpineKey.winPopup,
    path: 'atlasesNew/winPopups/mobile/winPopups.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/winPopups/mobile/winPopups.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winLine: {
    name: slotSpineKey.winLine,
    path: 'atlasesNew/line/mobile/winningLine.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/line/mobile/winningLine.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winSymbolBorder: {
    name: slotSpineKey.winSymbolBorder,
    path: 'atlasesNew/winSymbolBorder/mobile/winFrame.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/winSymbolBorder/mobile/winFrame.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  gambleAmountFrame: {
    name: slotSpineKey.gambleAmountFrame,
    path: 'atlasesNew/gambleFuture/mobile/amountFrame/amount.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/gambleFuture/mobile/amountFrame/amount.atlas',
      },
    },
  },
  gambleCard: {
    name: slotSpineKey.gambleCard,
    path: 'atlasesNew/gambleFuture/mobile/card/card.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/gambleFuture/mobile/card/card.atlas',
      },
    },
  },
  gambleSymbol: {
    name: slotSpineKey.gambleSymbol,
    path: 'atlasesNew/gambleFuture/mobile/symbol/symbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/gambleFuture/mobile/symbol/symbol.atlas',
      },
    },
  },
  winCoin: {
    name: slotSpineKey.winCoin,
    path: 'atlasesNew/winCoin/mobile/winCoin.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/winCoin/mobile/winCoin.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelLamp: {
    name: slotSpineKey.wheelLamp,
    path: 'atlasesNew/boostedJackpotAtlases/wheelLamp/mobile/wheelLamp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/wheelLamp/mobile/wheelLamp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelBlueBoard: {
    name: slotSpineKey.wheelBlueBoard,
    path: 'atlasesNew/boostedJackpotAtlases/wheelBlueBoard/mobile/wheelBlueBoard.json',
    config: {
      metadata: {
        spineAtlasFile:
          'atlasesNew/boostedJackpotAtlases/wheelBlueBoard/mobile/wheelBlueBoard.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelIcon: {
    name: slotSpineKey.wheelIcon,
    path: 'atlasesNew/boostedJackpotAtlases/wheelIcon/mobile/wheelIcon.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/wheelIcon/mobile/wheelIcon.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelSpinIcon: {
    name: slotSpineKey.wheelSpinIcon,
    path: 'atlasesNew/boostedJackpotAtlases/spinButton/mobile/spinButton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/spinButton/mobile/spinButton.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  popup: {
    name: slotSpineKey.popup,
    path: 'atlasesNew/boostedJackpotAtlases/popup/mobile/popUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/popup/mobile/popUp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  lightning: {
    name: slotSpineKey.lightning,
    path: 'atlasesNew/boostedJackpotAtlases/lightning/mobile/lightning.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/boostedJackpotAtlases/lightning/mobile/lightning.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

const webAtlases = {
  images: {
    name: 'images',
    path: 'atlasesNew/images/web/images.json',
  },
  licenseImages: {
    name: 'licenseImages',
    path: 'atlasesNew/images/web/licenseImages.json',
  },
  boostedJackpot: {
    name: 'boostedJackpot',
    path: 'atlasesNew/images/web/boostedJackpot.json',
  },
  jackpot: {
    name: 'jackpot',
    path: 'atlasesNew/images/web/jackpot.json',
  },
  gameImages: {
    name: 'gameImages',
    path: 'atlasesNew/images/web/gameImages.json',
  },
  infoSection: {
    name: 'infoSection',
    path: 'atlasesNew/images/web/infoSection.json',
  },
};

const mobileAtlases = {
  images: {
    name: 'images',
    path: 'atlasesNew/images/mobile/images.json',
  },
  licenseImages: {
    name: 'licenseImages',
    path: 'atlasesNew/images/web/licenseImages.json',
  },
  boostedJackpot: {
    name: 'boostedJackpot',
    path: 'atlasesNew/images/mobile/boostedJackpot.json',
  },
  jackpot: {
    name: 'jackpot',
    path: 'atlasesNew/images/mobile/jackpot.json',
  },
  gameImages: {
    name: 'gameImages',
    path: 'atlasesNew/images/mobile/gameImages.json',
  },
  infoSection: {
    name: 'infoSection',
    path: 'atlasesNew/images/mobile/infoSection.json',
  },
};

export const initialResourceWeb = {
  loading: {
    name: 'loading',
    path: 'atlasesNew/loading/web/loading.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/loading/web/loading.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

export const initialResourceMobile = {
  loading: {
    name: 'loading',
    path: 'atlasesNew/loading/mobile/loading.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlasesNew/loading/mobile/loading.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

export const initialGameResources = [
  ...Object.values(isMobile() ? initialResourceMobile : initialResourceWeb),
];

export const gameResources = [
  ...Object.values(fonts),
  ...Object.values(bitmapFonts),
  ...Object.values(isMobile() ? mobileSceneSpineResources : webSceneSpineResources),
  ...Object.values(isMobile() ? mobileAtlases : webAtlases),
];
